import Modal from "../../../../../components/Modal/Modal";
import styles from "./certificateModal.module.scss";
import ButtonShared from "../../../../../components/Button/Button";
import { useEffect, useState } from "react";
import { images } from "../../../../../constants/images";
import { CertificateModalProps } from "../../../../../interfaces/components";

const CertificateModal = ({
    open, 
    setOpen, 
    handlePress,
    certificate
}: CertificateModalProps) => {
    const [showConfirmationSection, setShowConfirmationSection] = useState<any>({absolute: true, show: false, type: "success"});
    const [showCertificateSection, setShowCertificateSection] = useState<any>({absolute: false, show: true});

    const onPress = () => {
        handlePress();
    }
    
    useEffect(() => {
        if(certificate?.fetching === "failure"){
            setShowCertificateSection({...showCertificateSection, show: false, type: "failure"});
            setTimeout(() => setShowCertificateSection({show: false, absolute: true, type: "failure"}), 500);
            setTimeout(() => setShowConfirmationSection({absolute: false, show: true}), 500);
        }
        if(certificate?.fetching === "success"){
            setShowCertificateSection({...showCertificateSection, show: false, type: "success"});
            setTimeout(() => setShowCertificateSection({show: false, absolute: true, type: "success"}), 500);
            setTimeout(() => setShowConfirmationSection({absolute: false, show: true}), 500);
        }
    }, [certificate?.fetching]);

    const onClose = () => {
        if(certificate?.fetching === "loading") return;
        setOpen(false);
        setShowConfirmationSection({absolute: true, show: false});
        setShowCertificateSection({absolute: false, show: true});
    }

    return(
        <Modal open={open} onClose={onClose} variant="white">
            <div className={`${styles.modalContainer} ${showConfirmationSection?.show && styles.show} ${showConfirmationSection?.absolute && styles.absolute}`}>
                {
                    showCertificateSection?.type === "success" &&
                    <img alt="success" src={images.successModalBlack} className={styles.image} />
                }
                <p className={styles.title}>
                    {
                        showCertificateSection?.type === "success"
                        ?   "Vehículo verificado"
                        :   "¡Ups!"
                    }
                </p>
                {
                    showCertificateSection?.type === "failure" &&
                    <p className={styles.subtitle}>Ha ocurrido un error al verificar este vehículo</p>
                }
                <div className={styles.buttons}>
                    <ButtonShared
                        onPress={onClose}
                        title="Aceptar" 
                        primary
                        size="small"
                        className={styles.button}
                    />
                </div>
            </div>
            <div className={`${styles.modalContainer} ${showCertificateSection?.show && styles.show} ${showCertificateSection?.absolute && styles.absolute}`}>
                <p className={styles.title}>¿Seguro que quieres verificar este vehículo?</p>
                <div className={styles.buttons}>
                    <ButtonShared
                        onPress={onClose}
                        title="Regresar" 
                        tertiary
                        size="small"
                        className={styles.button}
                        disabled={certificate?.fetching === "loading"}
                    />
                    <ButtonShared
                        onPress={onPress}
                        title="Verificar" 
                        primary
                        size="small"
                        className={styles.button}
                        loading={certificate?.fetching === "loading"}
                    />
                </div>
            </div>
        </Modal>
    )
};

export default CertificateModal;